import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListCountries } from "../../../components/Admin/Countries";
import { useLanguage } from "../../../contexts";
import "./Countries.scss";

export function Countries() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: t("active_countries"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListCountries countriesActive={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_countries"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListCountries countriesActive={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="countries-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="countries-page-header-wrapper">
        <div className="countries-page-header">
          <span className="countries-page-title">{translations.countries}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
